import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import { Avatar, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '../../assets/icons/ri_menu-4-fill.svg';
import React, { useState } from 'react';
import logoImg from '../../assets/logo/logo-sidebar.svg';
import Button from '../button/Button';
import IconText from '../icon-text/IconText';
import './sidebar.scss';
import { permissions, ROUTES_PATH } from '../../utility/constants';
import { useNavigate, useLocation } from 'react-router-dom';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Tooltip from '@mui/material/Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import { setHeaderTitle, setNestedSidebar, setSidebarListOpen, setSidebarNestedMasterListOpen, setSidebarNestedReportListOpen } from '../../store/slice/navigate/navigateSlice';
import DashboardIconNew from '../svg/DashboardIconNew';
import CourseNew from '../svg/CourseNew';
import InquiryNew from '../svg/InquiryNew';
import BranchNew from '../svg/BranchNew';
import FacultyNew from '../svg/FacultyNew';
import EnrollmentNew from '../svg/EnrollmentNew';
import TimeTableNew from '../svg/TimeTableNew';
import StudentNew from '../svg/StudentNew';
import ExamAssessmentNew from '../svg/ExamAssessmentNew';
import InventoryNew from '../svg/InventoryNew';
import ReportsNew from '../svg/ReportsNew';
import Fees from '../svg/FeesIcon';
import BillingIcon from '../svg/BillingIcon';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { getInitials } from '../../utility/genricFunction';
import adminLogo from '../../assets/logo/admin-logo-img.png';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import LocationCityIcon from '@mui/icons-material/LocationCity'
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined'
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined'

const drawerWidth = 263;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.linear,
    duration: 400,
  }),
  '@media only screen and (max-width:1700px)': {
    width: 221,
  },
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.linear,
    duration: 400,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));


export default function Sidebar({ open, setOpen }) {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth) || {};
  const { facultyProfilePhoto } = useSelector((state) => state.facultyProfile);
  const userData = useSelector((store) => store?.auth?.user?.result?.userData?.userPermission);
  const { sidebarNestedReports, sidebarNestedMaster, nestedSidebar } = useSelector((state) => state.navigate);

  const userPhotoUrl = facultyProfilePhoto ? facultyProfilePhoto.userPhotoUrl : user?.result?.userPhotoUrl;

  const roleName = user?.result?.userData?.roleName;
  const userName = user?.result?.userData?.userName;
  const profileLogo = roleName == 'admin' ? adminLogo : userPhotoUrl;

  const renderRole = (role) => {
    switch (role) {
      case 'branch':
        return role == 'branch'
          ? role.charAt(0).toUpperCase() + role.slice(1) + ' Admin'
          : role.charAt(0).toUpperCase() + role.slice(1);
      case 'inquiry':
        return role == 'inquiry'
          ? role.charAt(0).toUpperCase() + role.slice(1) + ' Manager'
          : role.charAt(0).toUpperCase() + role.slice(1);
      default:
        return roleName && roleName?.charAt(0)?.toUpperCase() + roleName?.slice(1);
    }
  };

  const position = renderRole(roleName);

  let navItems = [];

  if (roleName == 'admin') {
    navItems = [
      {
        icon: (rootRoute) => (
          <DashboardIconNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />
        ),
        name: 'Dashboard',
        rootRoute: '/dashboard',
        route: ROUTES_PATH.DASHBOARD,
        permission: permissions.ADMIN_DASHBOARD,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <CourseNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Course',
        rootRoute: '/course',
        route: ROUTES_PATH.COURSE,
        permission: permissions.VIEW_COURSE,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <InquiryNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Inquiry',
        rootRoute: '/inquiry',
        route: ROUTES_PATH.INQUIRY,
        permission: permissions.VIEW_INQUIRY,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <BranchNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Branch',
        rootRoute: '/branch',
        route: ROUTES_PATH.BRANCH,
        permission: permissions.VIEW_BRANCH,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <FacultyNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Faculty',
        rootRoute: '/faculty',
        route: ROUTES_PATH.FACULTY,
        permission: permissions.VIEW_FACULTY,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <EnrollmentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Enrollment',
        rootRoute: '/enrollment',
        route: ROUTES_PATH.ENROLLMENT,
        permission: permissions.VIEW_ENROLLMENT,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <TimeTableNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Time Table',
        rootRoute: '/timetable',
        route: ROUTES_PATH.TIMETABLE,
        permission: permissions.VIEW_TIMETABLE,
        subMenu: [],
      },
      // {
      //   icon: (rootRoute) => <AttendanceNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
      //   name: 'Attendance',
      //   rootRoute: '/attendance',
      //   route: ROUTES_PATH.ATTENDANCE,
      //   subMenu: [],
      // },
      // {
      //   icon: (rootRoute) => (
      //     <ExamAssessmentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />
      //   ),
      //   name: 'Exam Assessment',
      //   rootRoute: '/exam-assessment',
      //   route: ROUTES_PATH.EXAM_ASSESSMENT,
      //   subMenu: [],
      // },
      {
        icon: (rootRoute) => <InventoryNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Inventory',
        rootRoute: '/inventory',
        route: ROUTES_PATH.INVENTORY,
        permission: permissions.VIEW_INVENTORY,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <ReportsNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Role Management',
        rootRoute: '/role-management',
        route: ROUTES_PATH.ROLE_MANAGEMENT,
        permission: permissions.VIEW_ROLE,
        subMenu: [],
      },
      {
        icon: (rootRoute) => (
          <PeopleOutlineIcon sx={{ color: `${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}` }} />
        ),
        name: 'User Management',
        rootRoute: '/user-management',
        route: ROUTES_PATH.USER_MANAGEMENT,
        permission: permissions.VIEW_USERS,
        subMenu: [],
      },
      {
        icon: (rootRoute) => (
          <ManageAccountsOutlinedIcon
            sx={{ color: `${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}` }}
          />
        ),
        name: 'Configuration',
        rootRoute: '/configuration',
        route: ROUTES_PATH.CONFIGURATION,
        permission: permissions.VIEW_USERS,
        subMenu: [],
      },
      // {
      //   icon: (rootRoute) => <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
      //   name: 'Inquiry source',
      //   rootRoute: '/inquirySource',
      //   route: ROUTES_PATH.INQUIRY_SOURCE,
      //   permission: permissions.VIEW_INQUIRY,
      //   subMenu: [],
      // },
      {
        icon: (rootRoute) => (
          <SettingsOutlinedIcon sx={{ color: `${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}` }} />
        ),
        name: 'Master',
        rootRoute: '/master',
        route: ROUTES_PATH.MASTER,
        type: 'master',
        permission: permissions.VIEW_USERS,
        subMenu: [
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Inquiry source',
            rootRoute: '/inquirySource',
            route: ROUTES_PATH.INQUIRY_SOURCE,
            permission: permissions.VIEW_INQUIRY,
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <LocationCityIcon sx={{ color: `${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}` }} />
            ),
            name: 'Area',
            rootRoute: '/area-list',
            route: ROUTES_PATH.AREA,
            permission: permissions.VIEW_INQUIRY,
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <WorkspacePremiumOutlinedIcon sx={{ color: `${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}` }} />
            ),
            name: 'Education Qualification',
            rootRoute: '/education-qualification',
            route: ROUTES_PATH.EDUCATION_QUALIFICATION,
            permission: permissions.VIEW_INQUIRY,
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <AccountBalanceOutlinedIcon sx={{ color: `${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}` }} />
            ),
            name: 'Banks',
            rootRoute: '/Banks',
            route: ROUTES_PATH.BANKS,
            permission: permissions.VIEW_INQUIRY,
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Designation',
            rootRoute: '/Designation',
            route: ROUTES_PATH.DESIGNATION,
            permission: permissions.VIEW_INQUIRY,
            subMenu: [],
          },
        ],
      },
      {
        icon: (rootRoute) => <ReportsNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Reports',
        rootRoute: '/reports',
        route: ROUTES_PATH.REPORTS,
        permission: permissions.VIEW_REPORTS,
        subMenu: [
          {
            icon: (rootRoute) => (
              <TimeTableNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Timetable',
            rootRoute: '/reports/time-table',
            route: ROUTES_PATH.TIMETABLE_REPORT,
            permission: permissions.VIEW_REPORTS,
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Kit Distribution',
            rootRoute: '/reports/kit-distribution',
            route: ROUTES_PATH.KIT_DISTRIBUTION_REPORT,
            permission: permissions.VIEW_REPORTS,
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Kit Summary',
            rootRoute: '/reports/kit-summary',
            route: ROUTES_PATH.KIT_SUMMARY_REPORT,
            permission: permissions.VIEW_REPORTS,
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Sourcewise Inquiry',
            rootRoute: '/reports/source-wise-inquiry',
            route: ROUTES_PATH.SOURCE_WISE_INQUIRY_REPORT,
            permission: permissions.VIEW_REPORTS,
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Daily Report',
            rootRoute: '/reports/daily-report',
            route: ROUTES_PATH.DAILY_REPORT,
            permission: permissions.VIEW_REPORTS,
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Inquiry',
            rootRoute: '/reports/inquiry-report',
            route: ROUTES_PATH.INQUIRY_REPORT,
            permission: permissions.VIEW_REPORTS,
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Areawise inquiry',
            rootRoute: '/reports/areawise-inquiry-report',
            route: ROUTES_PATH.AREA_WISE_INQUIRY_REPORT,
            permission: permissions.VIEW_REPORTS,
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Fees Report',
            rootRoute: '/reports/feesCollection-report',
            route: ROUTES_PATH.FEES_COLLECTION_REPORT,
            permission: 'LIST_COURSE',
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Fees Outstanding Report',
            rootRoute: '/reports/fees-outstanding-report',
            route: ROUTES_PATH.TOTAL_DUE_FEES,
            permission: 'EDIT_ENROLLMENT',
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Student Report',
            rootRoute: '/reports/studentDetails-report',
            route: ROUTES_PATH.STUDENT_DETAILS_REPORT,
            permission: 'LIST_COURSE',
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Attendance',
            rootRoute: '/reports/attendance-report',
            route: ROUTES_PATH.ATTENDANCE_REPORT,
            permission: 'LIST_COURSE',
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Exam Result',
            rootRoute: '/reports/examResult-report',
            route: ROUTES_PATH.EXAM_RESULT_REPORT,
            permission: 'LIST_COURSE',
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Faculty Lecture',
            rootRoute: '/reports/facultyLecture-report',
            route: ROUTES_PATH.FACULTY_LECTURE_REPORT,
            permission: 'LIST_COURSE',
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Lecture Count',
            rootRoute: '/reports/lectureCount-report',
            route: ROUTES_PATH.LECTURE_COUNT_REPORT,
            permission: 'LIST_COURSE',
            subMenu: [],
          },
        ],
      },
      {
        icon: (rootRoute) => <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Placements',
        rootRoute: '/placements',
        route: ROUTES_PATH.PLACEMENTS,
        permission: permissions.VIEW_PLACEMENTS,
        subMenu: [],
      },
    ]
  } else if (roleName == 'branch') {
    navItems = [
      {
        icon: (rootRoute) => (
          <DashboardIconNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />
        ),
        name: 'Dashboard',
        rootRoute: '/dashboard',
        route: ROUTES_PATH.DASHBOARD,
        permission: permissions.ADMIN_DASHBOARD,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <CourseNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Course',
        rootRoute: '/course',
        route: ROUTES_PATH.COURSE,
        permission: permissions.VIEW_COURSE,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <InquiryNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Inquiry',
        rootRoute: '/inquiry',
        route: ROUTES_PATH.INQUIRY,
        permission: permissions.VIEW_INQUIRY,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <BranchNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Branch',
        rootRoute: '/branch',
        route: ROUTES_PATH.BRANCH,
        permission: permissions.VIEW_BRANCH,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <FacultyNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Faculty',
        rootRoute: '/faculty',
        route: ROUTES_PATH.FACULTY,
        permission: permissions.VIEW_FACULTY,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <EnrollmentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Enrollment',
        rootRoute: '/enrollment',
        route: ROUTES_PATH.ENROLLMENT,
        permission: permissions.VIEW_ENROLLMENT,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <TimeTableNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Time Table',
        rootRoute: '/timetable',
        route: ROUTES_PATH.TIMETABLE,
        permission: permissions.VIEW_TIMETABLE,
        subMenu: [],
      },
      // {
      //   icon: (rootRoute) => <AttendanceNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
      //   name: 'Attendance',
      //   rootRoute: '/attendance',
      //   route: ROUTES_PATH.ATTENDANCE,
      //   subMenu: [],
      // },
      // {
      //   icon: (rootRoute) => (
      //     <ExamAssessmentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />
      //   ),
      //   name: 'Exam Assessment',
      //   rootRoute: '/exam-assessment',
      //   route: ROUTES_PATH.EXAM_ASSESSMENT,
      //   subMenu: [],
      // },
      {
        icon: (rootRoute) => <InventoryNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Inventory',
        rootRoute: '/inventory',
        route: ROUTES_PATH.INVENTORY,
        permission: permissions.VIEW_INVENTORY,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <ReportsNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Role Management',
        rootRoute: '/role-management',
        route: ROUTES_PATH.ROLE_MANAGEMENT,
        permission: permissions.VIEW_ROLE,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'User Management',
        rootRoute: '/user-management',
        route: ROUTES_PATH.USER_MANAGEMENT,
        permission: permissions.VIEW_USERS,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Configuration',
        rootRoute: '/configuration',
        route: ROUTES_PATH.CONFIGURATION,
        permission: 'VIEW_CONFIGURATION',
        subMenu: [],
      },  
      {
        icon: (rootRoute) => <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Inquiry source',
        rootRoute: '/inquirySource',
        route: ROUTES_PATH.INQUIRY_SOURCE,
        permission: permissions.VIEW_INQUIRY,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <ReportsNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Reports',
        rootRoute: '/reports',
        route: ROUTES_PATH.REPORTS,
        permission: permissions.VIEW_REPORTS,
        subMenu: [
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Timetable',
            rootRoute: '/reports/time-table',
            route: ROUTES_PATH.TIMETABLE_REPORT,
            permission: permissions.VIEW_REPORTS,
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Kit Distribution',
            rootRoute: '/reports/kit-distribution',
            route: ROUTES_PATH.KIT_DISTRIBUTION_REPORT,
            permission: permissions.VIEW_REPORTS,
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Kit Summary',
            rootRoute: '/reports/kit-summary',
            route: ROUTES_PATH.KIT_SUMMARY_REPORT,
            permission: permissions.VIEW_REPORTS,
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Sourcewise Inquiry',
            rootRoute: '/reports/source-wise-inquiry',
            route: ROUTES_PATH.SOURCE_WISE_INQUIRY_REPORT,
            permission: permissions.VIEW_REPORTS,
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Daily Report',
            rootRoute: '/reports/daily-report',
            route: ROUTES_PATH.DAILY_REPORT,
            permission: permissions.VIEW_REPORTS,
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Inquiry',
            rootRoute: '/reports/inquiry-report',
            route: ROUTES_PATH.INQUIRY_REPORT,
            permission: permissions.VIEW_REPORTS,
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Areawise inquiry',
            rootRoute: '/reports/areawise-inquiry-report',
            route: ROUTES_PATH.AREA_WISE_INQUIRY_REPORT,
            permission: permissions.VIEW_REPORTS,
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Fees Report',
            rootRoute: '/reports/feesCollection-report',
            route: ROUTES_PATH.FEES_COLLECTION_REPORT,
            permission: 'LIST_COURSE',
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'fees Outstanding Report',
            rootRoute: '/reports/fees-outstanding-report',
            route: ROUTES_PATH.TOTAL_DUE_FEES,
            permission: 'EDIT_ENROLLMENT',
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Student Report',
            rootRoute: '/reports/studentDetails-report',
            route: ROUTES_PATH.STUDENT_DETAILS_REPORT,
            permission: 'LIST_COURSE',
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Attendance',
            rootRoute: '/reports/attendance-report',
            route: ROUTES_PATH.ATTENDANCE_REPORT,
            permission: 'LIST_COURSE',
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Exam Result',
            rootRoute: '/reports/examResult-report',
            route: ROUTES_PATH.EXAM_RESULT_REPORT,
            permission: 'LIST_COURSE',
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Faculty Lecture',
            rootRoute: '/reports/facultyLecture-report',
            route: ROUTES_PATH.FACULTY_LECTURE_REPORT,
            permission: 'LIST_COURSE',
            subMenu: [],
          },
          {
            icon: (rootRoute) => (
              <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'black' : 'black'}`} />
            ),
            name: 'Lecture Count',
            rootRoute: '/reports/lectureCount-report',
            route: ROUTES_PATH.LECTURE_COUNT_REPORT,
            permission: 'LIST_COURSE',
            subMenu: [],
          },
        ],
      },
      {
        icon: (rootRoute) => <StudentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Placements',
        rootRoute: '/placements',
        route: ROUTES_PATH.PLACEMENTS,
        permission: permissions.VIEW_PLACEMENTS,
        subMenu: [],
      },
    ]
  } else if (roleName == 'student') {
    navItems = [
      {
        icon: (rootRoute) => (
          <DashboardIconNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />
        ),
        name: 'Dashboard',
        rootRoute: '/dashboard',
        route: ROUTES_PATH.STUDENT_DASHBOARD,
        permission: permissions.STUDENT_DASHBOARD,
        subMenu: [],
      },
      {
        // icon: (rootRoute) => <Profile color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        icon: (rootRoute) => (
          <PersonOutlineIcon
            sx={{
              height: '28px',
              width: '28px',
              color: `${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`,
            }}
          />
        ),
        name: 'My Profile',
        rootRoute: '/student-profile',
        route: ROUTES_PATH.STUDENT_PROFILE,
        permission: permissions.VIEW_STUDENT_PROFILE,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <Fees color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Fees',
        rootRoute: '/student-fees',
        route: ROUTES_PATH.STUDENT_FEES,
        permission: permissions.VIEW_STUDENT_FEES,
        subMenu: [],
      },
      {
        icon: (rootRoute) => (
          <ExamAssessmentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />
        ),
        name: 'Exam',
        rootRoute: '/student-exam',
        route: ROUTES_PATH.STUDENT_EXAM,
        permission: permissions.VIEW_STUDENT_EXAM,
        subMenu: [],
      },
    ]
  } else if (roleName == 'faculty') {
    navItems = [
      {
        icon: (rootRoute) => (
          <DashboardIconNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />
        ),
        name: 'Dashboard',
        rootRoute: '/dashboard',
        route: ROUTES_PATH.DASHBOARD,
        permission: permissions.FACULTY_DASHBOARD,
        subMenu: [],
      },
      {
        icon: (rootRoute) => (
          <ExamAssessmentNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />
        ),
        name: 'Exam Assessment',
        rootRoute: '/exam-assessment/faculty',
        route: ROUTES_PATH.FACULTY_EXAM_ASSESSMENT,
        permission: permissions.VIEW_FACULTY_EXAM_ASSESSMENT,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <BillingIcon color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Billing History',
        rootRoute: '/billing-history',
        route: ROUTES_PATH.BILLING_HISTORY,
        permission: permissions.BILLING_HISTORY,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <TimeTableNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Time Table',
        rootRoute: '/timetable',
        route: ROUTES_PATH.TIMETABLE,
        permission: permissions.VIEW_TIMETABLE,
        subMenu: [],
      },
      {
        // icon: (rootRoute) => <Profile color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        icon: (rootRoute) => (
          <PersonOutlineIcon
            sx={{
              height: '28px',
              width: '28px',
              color: `${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`,
            }}
          />
        ),
        name: 'My Profile',
        rootRoute: '/faculty-profile',
        route: ROUTES_PATH.FACULTY_PROFILE,
        permission: permissions.VIEW_FACULTY_PROFILE,
        subMenu: [],
      },
    ]
  } else if (roleName == 'inquiry') {
    navItems = [
      {
        icon: (rootRoute) => (
          <DashboardIconNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />
        ),
        name: 'Dashboard',
        rootRoute: '/dashboard',
        route: ROUTES_PATH.DASHBOARD,
        permission: permissions.ADMIN_DASHBOARD,
        subMenu: [],
      },
      {
        icon: (rootRoute) => <InquiryNew color={`${location?.pathname?.split("/").includes(rootRoute.slice(1)) ? 'white' : 'black'}`} />,
        name: 'Inquiry',
        rootRoute: '/inquiry',
        route: ROUTES_PATH.INQUIRY,
        permission: permissions.VIEW_INQUIRY,
        subMenu: [],
      },
    ]
  }

  const handleDrawerClose = () => {
    setOpen(!open)
    dispatch(setSidebarListOpen(!open))

    if (nestedSidebar) {
      dispatch(setNestedSidebar(null))
    }

    if (sidebarNestedReports) {
      dispatch(setSidebarNestedReportListOpen(!sidebarNestedReports))
    }
    if (sidebarNestedMaster) {
      dispatch(setSidebarNestedMasterListOpen(!sidebarNestedMaster))
    }
  };

  const splitText = (text) => {
    const words = text.split(' ')
    let accumulatedLength = 0
    const maxLength = 19
    const result = []

    words.forEach((word, index) => {
      // Check if adding this word exceeds the max length
      if (accumulatedLength + word.length > maxLength) {
        result.push(<br key={`br-${index}`} />)
        accumulatedLength = 0 // Reset the accumulated length
      }

      result.push(
        <span key={`word-${index}`}>
          {word}
          {index < words.length - 1 && ' '}
        </span>,
      )

      accumulatedLength += word.length + 1 // Include space in length
    })

    return result
  }

  const NestedList = ({ item, subItems }) => {
    const [open, setOpen] = useState(false);
    const { sidebarListOpen, sidebarNestedReports, nestedSidebar } = useSelector((state) => state.navigate);

    if (!open) {
      dispatch(setSidebarListOpen(false));
    }

    const handleClick = (NestedItem) => {
      setOpen(true);
      dispatch(setSidebarListOpen(!sidebarListOpen));
      dispatch(setSidebarNestedReportListOpen(!sidebarNestedReports))

      dispatch(setNestedSidebar(NestedItem.name == nestedSidebar ? null : NestedItem.name))

    };


    // const isTabMaster = item.name == "Master" ? sidebarNestedMaster : sidebarNestedReports

    return (
      <List
        sx={{
          width: '100%',
          maxWidth: 360,
          padding: 0,
          listStyle: 'none',
          textDecoration: 'none',
        }}
        component='nav'
        aria-labelledby='nested-list-subheader'
      >
        <ListItemButton
          onClick={() => handleClick(item)}
          className={`sidebar-icon-wrapper ${open === true ? 'sidebar-icon-wrapper-radius' : ''} ${location.pathname.includes(item.rootRoute) ? 'active' : 'in-active'}-tab`}
        >
          <IconText
            text={item.name}
            icon={item.icon(item.rootRoute)}
            textColor={location.pathname.includes(item.rootRoute) ? 'white' : 'black'}
            textWeight='500'
            textType='sidebar'
          />
          {item.name == nestedSidebar ? (
            <ExpandLess
              sx={{
                color: location.pathname.includes(item.rootRoute) ? 'white' : 'black',
                fontSize: '24px',
                fontWeight: 'normal',
                margin: '2px 0 0 15px',
              }}
            />
          ) : (
            <ExpandMore
              sx={{
                color: location.pathname.includes(item.rootRoute) ? 'white' : 'black',
                fontSize: '24px',
                fontWeight: 'normal',
                margin: '2px 0 0 15px',
              }}
            />
          )}
        </ListItemButton>
        <Collapse in={item.name == nestedSidebar} timeout='auto' unmountOnExit> {/* Use reportsOpen state here */}
          <List
            sx={{
              listStyle: 'none',
              textDecoration: 'none',
            }}
            component='div'
            disablePadding
          >
            {subItems?.map((subItem, index) => (
              <ListItemButton
                className={`sidebar-icon-wrapper-nested ${open === true ? 'sidebar-icon-wrapper-radius-nested' : ''}  ${location.pathname.includes(subItem.route) ? 'active' : 'in-active'}-tab`}
                key={index}
                sx={{
                  pl: 4,
                  bgcolor: '#FFF9F9',
                  wordBreak: "word-wrap",
                  marginLeft: '-85px',
                  borderBottom: '1px solid rgba(238, 78, 86, 0.05)',
                  '&.MuiButtonBase-root.MuiListItemButton-root': {
                    '&:hover': {
                      // backgroundColor: '#ee4e561a',
                    },
                  },
                }}
                onClick={() => {
                  dispatch(setHeaderTitle([subItem.name]));
                  navigate(subItem.route);
                }}
              >
                <IconText
                  icon={subItem.icon(subItem.rootRoute)}
                  text={splitText(subItem.name)}
                  // text={subItem.name}
                  textWeight={location.pathname.includes(subItem.route) ? '700' : '500'}
                  textType='sidebar'
                />
              </ListItemButton>
            ))}
          </List>
        </Collapse>
      </List>
    )
  };

  const MenuItem = ({ list }) => {
    return list.map((item, index) => {
      const CustomToolTip = ({ name, show, children }) => {
        return show ? (
          <Tooltip title={name} placement='bottom-start'>
            {children}
          </Tooltip>
        ) : (
          <>{children}</>
        );
      };

      if (userData?.includes(item.permission)) {
        return (
          <React.Fragment key={item.name}>
            {item.subMenu.length <= 0 && (
              <CustomToolTip name={item.name} show={!open}>
                <div>
                  <Button
                    className={`sidebar-icon-wrapper ${open === true ? 'sidebar-icon-wrapper-radius' : ''}  ${location?.pathname?.split("/").includes(item.rootRoute.slice(1)) ? 'active' : 'in-active'}-tab ${index == list.length - 1 ? 'mb-10' : ''}`}
                    key={index}
                    type='button'
                    onClick={() => {
                      navigate(item.route);
                      dispatch(setHeaderTitle([item.name]));
                    }}
                  >
                    <IconText
                      text={item.name}
                      icon={item.icon(item.rootRoute)}
                      textColor={location.pathname.split("/").includes(item.rootRoute.slice(1)) ? 'white' : 'black'}
                      textWeight='500'
                      textType='sidebar'
                    />
                  </Button>
                </div>
              </CustomToolTip>
            )}


            {item.subMenu.length > 0 && (
              <NestedList
                key={`${item.name}-submenu`}
                item={item}
                subItems={item.subMenu}
              />
            )}
          </React.Fragment>
        );
      }
    });
  };

  return (
    <>
      <Box sx={{ display: 'flex' }}>
        <Drawer
          variant='permanent'
          open={open}
          sx={{
            '& .MuiPaper-root': {
              '&::-webkit-scrollbar': {
                display: 'none',
              },
            },
          }}
        >
          <DrawerHeader sx={{ height: '80px', position: 'sticky', top: ' 0px', zIndex: '5', backgroundColor: 'white' }}>
            <Typography textColor='red'>
              <img className='logo-img-sidebar' src={logoImg} />
            </Typography>

            <IconButton sx={{ marginRight: '2px' }} onClick={handleDrawerClose}>
              <img src={MenuIcon} />
            </IconButton>
          </DrawerHeader>
          {open ? (
            <Box className='flex justify-center align-center flex-column profile'>
              <Avatar alt={userName} src={profileLogo} className='userlogo'>
                {getInitials(userName)}
              </Avatar>
              <Typography className='profile-name'>{userName}</Typography>
              <Typography className='profile-post'>{position}</Typography>
            </Box>
          ) : (
            ''
          )}
          <hr style={{ border: '0.5px solid #E2EAED', marginBottom: '20px' }} />
          <div className={`nav-items-container flex flex-column ${open === true ? 'nav-items-container-padding' : ''}`}>
            <MenuItem list={navItems} />
          </div>
        </Drawer>
      </Box>
    </>
  );
}
